// Single source of truth for the backend API base URL.
//
// Resolution order:
//   1. If USE_RELATIVE_API is on (Cloudflare Worker proxy mode), return "" —
//      all fetch() calls will hit the CURRENT origin, which the edge Worker
//      then forwards to the backend. Same-origin: no CORS, no visible backend
//      host in the browser Network tab.
//   2. Otherwise use the runtime API_URL from public/config.js (editable on
//      the server without a rebuild) — this is the direct-to-backend path.
//   3. Otherwise use the build-time REACT_APP_BACKEND_URL.
//   4. Last resort: the current window origin (never a preview/dev URL).
export const getApiBase = () => {
  const cfg = (typeof window !== 'undefined' && window.__SAG_CONFIG__) || {};
  if (cfg.USE_RELATIVE_API === true) return '';
  return cfg.API_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin;
};
